import React, { Component, Suspense } from 'react';
import { Card, Form, Col, Button, Jumbotron } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import XLSX from 'xlsx';
import { modalActionCreator } from '../../store/actions/modalActions';
import { TabList, TabItem } from '../../controls'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheck, faPen, faChevronCircleRight, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

import { CodingEventService } from '../../services/';

class CodingEventImport extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            viewModel: {
                customers: [{ contacts: [] }],
                contacts: [],
                linesOfBusiness: [],
                codingEventQueues: [],
                services: [],
                caseOrigins: []
            },

            refDataIndexes: [],


            selectedFile: { name: "Coding event import file (.xlsx)" },
            processedEvents: [],

            isValidEventImportFile: false,
            processedEventsValid: false,

            selectedCustomerId: 0,
            selectedContactId: 0,
            selectedCaseOriginId: 0,
            selectedCodingEventQueueId: 0,
            selectedAssignedToId: 0,
            selectedLineOfBusinessId: 0,
            selectedServiceRequestId: 0,

            importedData: [],
            data: [],
            columnLabels: []
        };

        this.handleImport = this.handleImport.bind(this);
        this.handleFileImport = this.handleFileImport.bind(this);

        this.handleUserInput = this.handleUserInput.bind(this);
        this.handleImportSelection = this.handleImportSelection.bind(this);
        this.handleEventEditInput = this.handleEventEditInput.bind(this);
        this.buildEventPocoArray = this.buildEventPocoArray.bind(this);
        this.handleRemoveRow = this.handleRemoveRow.bind(this);
        this.handleSelectedCustomerInput = this.handleSelectedCustomerInput.bind(this);
        this.updateSelectedCustomer = this.updateSelectedCustomer.bind(this);
        this.handleSelectedCodingEventQueueInput = this.handleSelectedCodingEventQueueInput.bind(this);
        this.updateSelectedCodingEventQueue = this.updateSelectedCodingEventQueue.bind(this);
        this.handleSelectedAssignedToInput = this.handleSelectedAssignedToInput.bind(this);
        this.updateSelectedAssignedTo = this.updateSelectedAssignedTo.bind(this);
        this.handleEventEditCustomerInput = this.handleEventEditCustomerInput.bind(this);
        this.clearProcessedEvents = this.clearProcessedEvents.bind(this);
        this.resetSelectedCodingEventQueue = this.resetSelectedCodingEventQueue.bind(this);
        this.handleSelectedLineOfBusinessInput = this.handleSelectedLineOfBusinessInput.bind(this);
    }

    async componentDidMount() {
        // get vm
        const codingEventService = new CodingEventService();

        var callResult = await codingEventService.getImportViewModel();
        if (callResult.result) {
            this.setState({ viewModel: callResult.model });
        }
        this.createRefDataIndexes(this.state.viewModel);
    }

    async handleImport() {
        
            var codingEventService = new CodingEventService();
            // Create an object of formData 
            const formData = new FormData();

            // Update the formData object 
            if (this.state.selectedFile.name !== 'Coding event import file (.xlsx)') {
                formData.append(
                    "formFile",
                    this.state.selectedFile,
                    this.state.selectedFile.name
                );
            }
            else {
                // throw error here todo
            }
            formData.append(
                "codingEvents", JSON.stringify(this.state.processedEvents)
            );
            var result = await codingEventService.importCodingEvents(formData);
            this.props.history.push({
                pathname: '/coding/importresults',
                data: result // your data array of objects
            })
            //this.setState({ results: result})

    }

    clearProcessedEvents() {
        this.setState({ processedEvents: [], data: [] });
    }

    handleUserInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const tmpValue = target.type === 'checkbox' ? target.checked : target.value;
        const isNumber = target.getAttribute("data-type") === "number";
        const value = isNumber ? parseInt(tmpValue) : tmpValue;
        const name = target.name;
        
        this.setState({ [name]: value });
    }

    handleSelectedCustomerInput(event) {

        const target = event.target;
        const newCustomerId = parseInt(target.value);
        this.updateSelectedCustomer(newCustomerId);

    }

    updateSelectedCustomer(newCustomerId) {
        const customerId = this.state.selectedCustomerId;
        let contactId = this.state.selectedContactId;
        let selectedLobId = this.state.selectedLineOfBusinessId;
        if (newCustomerId === 0) {
            // reset lob to 0 since customer id is 0
            selectedLobId = 0;
        }
        if (newCustomerId !== customerId) {
            contactId = 0;
        }

        this.setState({
            selectedCustomerId: newCustomerId,
            selectedContactId: contactId,
            selectedLineOfBusinessId: selectedLobId
        }, () => this.resetSelectedCodingEventQueue());
    }

    handleSelectedLineOfBusinessInput(event) {
        const target = event.target;
        const newLobId = parseInt(target.value);

        this.setState({ selectedLineOfBusinessId: newLobId }, () => this.resetSelectedCodingEventQueue());

    }

    resetSelectedCodingEventQueue() {
        let selectedQueueId = this.state.selectedCodingEventQueueId;
        let customerId = this.state.selectedCustomerId;
        const selectedLobId = this.state.selectedLineOfBusinessId;
        if (customerId > 0 && selectedLobId > 0) {
            let currentSelectedCustomer = this.state.refDataIndexes.customers[customerId];
            if (selectedQueueId !== currentSelectedCustomer.homecareQueueId ||
                selectedQueueId !== currentSelectedCustomer.hospiceQueueId) {
                if (this.state.selectedLineOfBusinessId === 1) {
                    selectedQueueId = currentSelectedCustomer.homecareQueueId;
                } else if (this.state.selectedLineOfBusinessId === 2) {
                    selectedQueueId = currentSelectedCustomer.hospiceQueueId !== 0
                        ? currentSelectedCustomer.hospiceQueueId
                        : 1;
                } else {
                    selectedQueueId = 0;
                }
            } else {
                selectedQueueId = 0;
            }
        } else {
            selectedQueueId = 0;
        }
        this.updateSelectedCodingEventQueue(selectedQueueId);
    }

    handleSelectedCodingEventQueueInput(event) {
        const target = event.target;
        const newQueueId = parseInt(target.value);

        this.updateSelectedCodingEventQueue(newQueueId);
    }

    updateSelectedCodingEventQueue(newQueueId) {
        const queueId = this.state.selectedCodingEventQueueId;
        let assignedToId = this.state.selectedAssignedToId;
        const selectedLobId = this.state.selectedLineOfBusinessId;
        if (newQueueId !== queueId || selectedLobId === 0) {
            assignedToId = 0;
        }

        this.setState({ selectedCodingEventQueueId: newQueueId, selectedAssignedToId: assignedToId });
    }

    handleSelectedAssignedToInput(event) {
        const target = event.target;
        const newAssignedToId = parseInt(target.value);

        this.updateSelectedAssignedTo(newAssignedToId);
    }

    updateSelectedAssignedTo(newAssignedToId) {
        this.setState({ selectedAssignedToId: newAssignedToId });
    }

    handleEventEditInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const name = target.name;
        const row = parseInt(target.getAttribute("row"));
        const tmpValue = target.type === 'checkbox' ? target.checked : target.value;
        const isNumber = target.getAttribute("data-type") === "number";
        const value = isNumber ? parseInt(tmpValue) : tmpValue;

        let partialState = [...this.state.processedEvents];

        partialState[row][name] = value;

        this.setState({ processedEvents: partialState }, () => this.validateProcessedEvents());
    }

    handleEventEditCustomerInput(event) {

        const target = event.target;
        const row = parseInt(target.getAttribute("row"));

        let partialState = [...this.state.processedEvents];


        const newCustomerId = parseInt(target.value);
        const customerId = partialState[row].accountId;
        let contactId = partialState[row].customerContactId;

        if (newCustomerId !== customerId) {
            contactId = 0;
        }

        partialState[row].accountId = newCustomerId;
        partialState[row].customerContactId = contactId;

        this.setState({ processedEvents: partialState }, () => this.validateProcessedEvents());
    }

    handleRemoveRow(rowId) {
        let rows = [...this.state.processedEvents];

        rows.splice(rowId, 1);
        
        this.setState({ processedEvents: rows }, () => this.validateProcessedEvents());

    }

    handleImportSelection(event) {
        //event.preventDefault();
        let files = event.target.files;

        if (files && files.length > 0) {
            this.setState({ selectedFile: files[0] }, () => this.handleFileImport(files[0]));
        }
        else
            console.log("no files selected");
    }

    getCustomerContacts() {

    }

    // create the indexes off of the vm for easy lookup.
    createRefDataIndexes(vm) {
        // faking this out for now

        let customerIndex = {};
        let customerContactIndex = {};

        // create indexes for customer, customerContacts,and contacts
        vm.customers.forEach((customer) => {
            customerContactIndex[parseInt(customer.id)] = {};
            customer.contacts.forEach((contact) => {
                customerContactIndex[customer.id][contact.emailAddress] = contact.id;
                customerContactIndex[customer.id][contact.id] = contact.emailAddress;
            });
            customerIndex[customer.id] = { ...customer };
        });

        // create queue index
        let queueIndex = {};
        vm.codingEventQueues.forEach((queue) => {
            queueIndex[queue.id] = { ...queue };
        });

        // create lob index;
        const lobIndex = {};
        vm.linesOfBusiness.forEach((lob) => {
            lobIndex[lob.id.toString()] = lob.name;
            lobIndex[lob.name] = lob.id;
        });

        // create services index
        const serviceIndex = {};
        vm.services.forEach((service) => {
            serviceIndex[service.id] = service.name;
            serviceIndex[service.name] = service.id;
        });

        // create case origins service
        const caseOriginIndex = {};
        vm.caseOrigins.forEach((origin) => {
            caseOriginIndex[origin.id] = origin.name;
            caseOriginIndex[origin.name] = origin.id;
        });



        // set state
        this.setState({
            refDataIndexes: {
                customers: customerIndex,
                customerContacts: customerContactIndex,
                lobs: lobIndex,
                services: serviceIndex,
                caseOrigins: caseOriginIndex,
                queues: queueIndex
            }
        });
    }

    buildEventPocoArray(columnHeaders, rowData) {


        let eventRows = [];
        rowData.forEach((row) =>
        {
            const newRow = {};

            // get the value for the customer id
            let accountId = 0;
            const accountValue = row[0];
            const account = !isNaN(accountValue) ? parseInt(accountValue) : null;

            // make sure that it is a valid customer, set the id if so
            if (account !== null && this.state.refDataIndexes.customers[account] != undefined) {
                accountId = account;
            }

            // if account was null - was there a default selected customer?
            if (accountId === 0 && this.state.selectedCustomerId !== 0) {
                accountId = this.state.selectedCustomerId;
            }

            newRow.accountId = accountId;




            // this requires no manipulation
            newRow.description = row[1];

            // get the value for the service selected
            let serviceRequestId = 0;
            const serviceValue = row[2];
            const serviceRequest = serviceValue.length > 0 ? serviceValue : null;

            if (serviceRequest !== null && this.state.refDataIndexes.services[serviceRequest] !== undefined) {
                serviceRequestId = this.state.refDataIndexes.services[serviceRequest];
            }
            // no data imported and nothing in selected default
            if (serviceRequest === null && this.state.selectedServiceRequestId !== 0) {
                serviceRequestId = this.state.selectedServiceRequestId;
            }

            newRow.serviceRequestId = serviceRequestId;


            // get the value for the case origin
            let caseOriginId = 0;
            const caseOriginValue = row[3];
            const caseOrigin = caseOriginValue.length > 0 ? caseOriginValue : null;

            if (caseOrigin !== null && this.state.refDataIndexes.caseOrigins[caseOrigin] !== undefined) {
                caseOriginId = this.state.refDataIndexes.caseOrigins[caseOrigin];
            }
            // no data imported  - check if default selection
            if (caseOrigin === null && this.state.selectedCaseOriginId !== 0) {
                caseOriginId = this.state.selectedCaseOriginId;
            }

            newRow.caseOriginId = caseOriginId;

            // get the value for LOB
            let lineOfBusinessId = 0;
            const lineOfBusinessValue = row[4];
            const lineOfBusiness = lineOfBusinessValue.length > 0 ? lineOfBusinessValue : null;

            if (lineOfBusiness !== null && this.state.refDataIndexes.lobs[lineOfBusiness] !== undefined) {
                lineOfBusinessId = this.state.refDataIndexes.lobs[lineOfBusiness];
            }
            // no data imported  - check if default selection
            if (lineOfBusiness === null && this.state.selectedLineOfBusinessId !== 0) {
                lineOfBusinessId = this.state.selectedLineOfBusinessId;
            }

            newRow.lineOfBusinessId = lineOfBusinessId;

            // find the queue
            // 1 is homecare
            // 2 is hospice
            if (lineOfBusinessId > 0 && accountId > 0) {
                // lets set the queue!
                var queueId = 0
                if (lineOfBusinessId === 1) {
                    // homecare
                    queueId = this.state.refDataIndexes.customers[accountId].homecareQueueId;
                } else if (lineOfBusinessId === 2) {
                    // hospice
                    queueId = this.state.refDataIndexes.customers[accountId].hospiceQueueId;
                }
                if (this.state.selectedCodingEventQueueId !== 0 && queueId === 0) {
                    queueId = this.state.selectedCodingEventQueueId;
                }
                newRow.codingEventQueueId = queueId;
            }

            if (this.state.selectedAssignedToId !== 0) {
                newRow.assignedToId = this.state.selectedAssignedToId;
            } else {
                newRow.assignedToId = 0;
            }


            // get the value for customer contact
            let customerContactId = 0;
            const customerContactValue = row[5];
            const customerContact = customerContactValue.length > 0 ? customerContactValue : null;
            let customerContacts = this.state.refDataIndexes.customerContacts[account];
            if (customerContact !== null
                && customerContacts !== undefined
                && customerContacts[customerContact] !== undefined) {
                customerContactId = customerContacts[customerContact];
            }
            // no data imported  - check if default selection
            if (customerContact === null && this.state.selectedContactId !== 0) {
                customerContactId = this.state.selectedContactId;
            }

            newRow.customerContactId = customerContactId;

            eventRows.push(newRow);
        });

        this.setState({ processedEvents: eventRows }, () => this.validateProcessedEvents());
    }

    validateProcessedEvents() {
        let eventRows = [...this.state.processedEvents];
        let processedEventsValid = true;
        eventRows.forEach((row, idx) => {
            let rowUnique = true;
            eventRows.forEach((innerRow, innerIdx) => {
                if (idx !== innerIdx) {
                    if (row.accountId === innerRow.accountId) {
                        if (row.description.trim() === innerRow.description.trim()) {
                            // duplicate
                            rowUnique = false;
                        }
                    }
                }
            });
            row.uniqueDescription = rowUnique;

            const rowValid = row.accountId !== 0 &&
                row.description.length > 0 &&
                row.serviceRequestid !== 0 &&
                row.caseOriginId !== 0 &&
                row.lineOfBusinessId !== 0 &&
                row.customerContactId !== 0 &&
                row.uniqueDescription;
            processedEventsValid = processedEventsValid && rowValid;
        });

        this.setState({ processedEvents: eventRows, processedEventsValid: processedEventsValid });
    }

    checkIfValidImportData(cols) {
        if (cols.length === 6 &&  // if the total column length is 6
                // and all of the column headers are in this indexed order
            cols.indexOf("CUSTOMERID") === 0 &&
            cols.indexOf("DESCRIPTION") === 1 &&
            cols.indexOf("REQUEST") === 2 &&
            cols.indexOf("CASEORIGIN") === 3 &&
            cols.indexOf("LOB") === 4 &&
            cols.indexOf("CUSTOMERCONTACT") === 5) {
            // then it is in the required import format for xlsx event import
            return true;
        }
        return false;
    }

    getColumnLabels(array) {
        let columnLabels = [];

        // shift the first row columns off of the file
        const cols = array.shift();

        // and push them into the colLabels
        cols.forEach((col) => {
            columnLabels.push(col);
        });
        return columnLabels;
    }

    async handleFileImport(file) {

        if (this.state.selectedFile.name != 'Coding event import file (.xlsx)') {
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;
            reader.onload = (e) => {
                /* Parse data */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

                let columnLabels = this.getColumnLabels(data);

                let isValidEventImportFile = this.checkIfValidImportData(columnLabels);

                if (isValidEventImportFile) {
                    // then it is in the required import format for xlsx event import
                    //isValidEventImportFile = true;
                } else {
                    // need to set error on state for display - invalid excel import file
                }
                this.setState(
                    { data: data, columnLabels: columnLabels, isValidEventImportFile: isValidEventImportFile }, () => {
                        if (isValidEventImportFile) {
                            this.buildEventPocoArray(columnLabels, data);
                        }
                    });
            };
            if (rABS) reader.readAsBinaryString(file);
            else reader.readAsArrayBuffer(file);
        }
    }

    render() {
        return (
            <div>
                <Card className={this.state.processedEvents.length > 0 ? "d-none" : null}>
                    <Card.Header className="d-flex align-items-center">
                        <div className="mr-auto">Import Coding Events</div>
                        <div className="card-btn-group">
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <TabList>
                            <TabItem label="Import from file">
                                <Form.Row>
                                    <Form.Group as={Col} lg={4}>
                                        <Form.Label>Choose file to import</Form.Label>
                                        <Form.File
                                            id="custom-file"
                                            label={this.state.selectedFile.name}
                                            onChange={(e) => this.handleImportSelection(e)}
                                            custom/>
                                    </Form.Group><br/>
                                    <Form.Group as={Col} lg={12}>
                                        <div>Excel file must be template provided. First sheet must be templated data containing: CUSTOMERID, DESCRIPTION, REQUEST, CASEORIGIN, LOB, and CUSTOMERCONTACT</div>
                                    </Form.Group>
                                </Form.Row>
                            </TabItem>
                            <TabItem label="Import by copy/paste">
                                <Jumbotron className="pt-2 pb-2">
                                    <Form.Row>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Customer</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedCustomerId}
                                                          name="selectedCustomerId"
                                                          id="selectedCustomerId"
                                                          data-type="number"
                                                          onChange={this.handleSelectedCustomerInput}>
                                                <option key={null} value={0}>Select Customer...</option>
                                                {
                                                this.state.viewModel.customers.map((customer, idx) => {
                                                    return <option key={idx} value={customer.id}>{customer.name + ' (' + customer.id + ')'}</option>
                                                })
                                            }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Contact</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedContactId}
                                                          name="selectedContactId"
                                                          id="selectedContactId"
                                                          data-type="number"
                                                          onChange={this.handleUserInput}
                                                          disabled={this.state.selectedCustomerId === 0 ? true : false}>

                                                <option value={0}>Select Contact...</option>
                                                {
                                                this.state.selectedCustomerId > 0 ?
                                                    this.state.refDataIndexes.customers[this.state.selectedCustomerId].contacts.map((contacts, idx) => {
                                                        return <option key={idx} value={contacts.id}>{contacts.name}</option>
                                                    }) : null
                                            }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Line of business</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedLineOfBusinessId}
                                                          name="selectedLineOfBusinessId"
                                                          id="selectedLineOfBusinessId"
                                                          data-type="number"
                                                          onChange={this.handleSelectedLineOfBusinessInput}
                                                          disabled={this.state.selectedCustomerId === 0 ? true : false}>
                                                <option value={0}>Select Line of Business...</option>
                                                {
                                                this.state.viewModel.linesOfBusiness.map((lob, idx) => {
                                                    return <option key={idx} value={lob.id}>{lob.name}</option>
                                                })
                                            }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Queue</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedCodingEventQueueId}
                                                          name="selectedCodingEventQueueId"
                                                          id="selectedCodingEventQueueId"
                                                          data-type="number"
                                                          onChange={this.handleSelectedCodingEventQueueInput}
                                                          disabled={this.state.selectedLineOfBusinessId === 0 || 
                                                    this.state.selectedCustomerId === 0 ? true : false}>
                                                <option value={0}>Select Queue...</option>
                                                {
                                                    this.state.viewModel.codingEventQueues.map((queue, idx) => {
                                                        return <option key={idx} value={queue.id}>{queue.name}</option>
                                                    })
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Assigned To</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedAssignedToId}
                                                          name="selectedAssignedToId"
                                                          id="selectedAssignedToId"
                                                          data-type="number"
                                                          onChange={this.handleSelectedAssignedToInput}
                                                          disabled={this.state.selectedCodingEventQueueId === 0 ? true : false}>
                                                <option value={0}>Select Employee...</option>
                                                {
                                                    this.state.selectedCodingEventQueueId > 0 ?
                                                    this.state.refDataIndexes.queues[this.state.selectedCodingEventQueueId].members.map((emp, idx) => {
                                                        return <option key={idx} value={emp.id}>{emp.name}</option>
                                                    }) : null
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Case origin</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedCaseOriginId}
                                                          name="selectedCaseOriginId"
                                                          id="selectedCaseOriginId"
                                                          data-type="number"
                                                          onChange={this.handleUserInput}>
                                                <option key={null} value={0}>Select Case Origin...</option>
                                                {
                                                this.state.viewModel.caseOrigins.map((co, idx) => {
                                                    return <option key={idx} value={co.id}>{co.name}</option>
                                                })
                                            }
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} lg="3" md="6">
                                            <Form.Label>Requested Service</Form.Label>
                                            <Form.Control as="select"
                                                          value={this.state.selectedServiceRequestId}
                                                          name="selectedServiceRequestId"
                                                          id="selectedServiceRequestId"
                                                          data-type="number"
                                                          onChange={this.handleUserInput}>
                                                <option value={0}>Select Service...</option>
                                                {
                                                this.state.viewModel.services.map((service, idx) => {
                                                    return <option key={idx} value={service.id}>{service.name}</option>
                                                })
                                            }
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>

                                    <div><b>* Default data will be used when there is no value for that field supplied in the copy/pasted data.</b></div>
                                </Jumbotron>
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>Import by copy/paste</Form.Label><br/>
                                        <Button variant="primary" onClick={() => this.props.showModal({
                                            open: true,
                                            modalSize: "lg",
                                            hideModal: this.props.hideModal,
                                            checkIfValidImportData: this.checkIfValidImportData,
                                            getColumnLabels: this.getColumnLabels,
                                            buildEventPocoArray: this.buildEventPocoArray
                                        }, 'importPastedCodingEvents')}>Import Copy/Pasted Raw Data</Button>
                                    </Form.Group>
                                </Form.Row>
                            </TabItem>
                        </TabList>
                        <br/><br/>
                        {
                            //<div><pre>
                            //{JSON.stringify(this.state, null, 2)}
                            //</pre></div>
                        }
                    </Card.Body>
                </Card>
                <Card className={this.state.processedEvents.length === 0 ? "d-none" : null}>
                    <Card.Header className="d-flex align-items-center">
                        <div className="mr-auto">Verify Pending Import Data</div>
                        <div className="card-btn-group">
                            <Button variant="danger" size="sm" onClick={() => this.clearProcessedEvents()}>Clear Events</Button>
                            <Button variant="success" size="sm" onClick={() => this.handleImport()} disabled={!this.state.processedEventsValid  ? true : false}>Import Events</Button>
                        </div>
                    </Card.Header>
                    <Card.Body className="card-body-table">
                        <table className="table table-striped table-hover">
                            <tr>
                                <th>#</th>
                                <th>Customer</th>
                                <th>Contact</th>
                                <th>Description</th>
                                <th>Request</th>
                                <th>Origin</th>
                                <th>LOB</th>
                                <th>Queue</th>
                                <th>Assigned To</th>
                                <th/>
                            </tr>
                            {
                                        //this.state.copyPasteData
                                        this.state.processedEvents.map((row, idx) => {
                                            return (
                                                <tr className={!row.uniqueDescription ? "table-danger" : null}>
                                                    <td>{idx + 1}</td>
                                                    <td>
                                                        <Form.Control as="select"
                                                            value={row.accountId}
                                                            name="accountId"
                                                            id="accountId"
                                                            row={idx}
                                                            data-type="number"
                                                            isInvalid={row.accountId === 0}
                                                            onChange={this.handleEventEditCustomerInput}>
                                                            <option key={null} value={0}>Select Customer...</option>
                                                            {
                                                                this.state.viewModel.customers.map((customer, idx) => {
                                                                    return <option key={idx} value={customer.id}>{customer.name}</option>
                                                                })
                                                            }
                                                        </Form.Control></td>

                                                    <td>
                                                        <Form.Control as="select"
                                                                      value={row.customerContactId}
                                                                      name="customerContactId"
                                                                      id="customerContactId"
                                                                      data-type="number"
                                                                      row={idx}
                                                                      onChange={this.handleEventEditInput}
                                                                      isInvalid={row.customerContactId === 0}
                                                                      disabled={row.accountId === 0 ? true : false}>
                                                            <option value={0}>Select Contact...</option>
                                                            {
                                                                row.accountId > 0 ?
                                                                    this.state.refDataIndexes.customers[row.accountId].contacts.map((contacts, idx) => {
                                                                        return <option key={idx} value={contacts.id}>{contacts.name}</option>
                                                                    }) : null
                                                            }
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        {row.description}
                                                        {
                                                        //<Form.Control value={row.description}
                                                        //    as="textarea"
                                                        //    rows="2"
                                                        //    name="description"
                                                        //    id="description"
                                                        //    row={idx}
                                                        //    onChange={this.handleEventEditInput}
                                                        //        isInvalid={row.description === "" || !row.uniqueDescription} />
                                                        }
                                                    </td>
                                                    <td>
                                                        <Form.Control as="select"
                                                            value={row.serviceRequestId}
                                                            name="serviceRequestId"
                                                            id="serviceRequestId"
                                                            row={idx}
                                                            data-type="number"
                                                            onChange={this.handleEventEditInput}
                                                            isInvalid={row.serviceRequestId === 0}>
                                                            <option value={0}>Select Service...</option>
                                                            {
                                                                this.state.viewModel.services.map((service, idx) => {
                                                                    return <option key={idx} value={service.id}>{service.name}</option>
                                                                })
                                                            }
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control as="select"
                                                            value={row.caseOriginId}
                                                            name="caseOriginId"
                                                            id="caseOriginId"
                                                            row={idx}
                                                            data-type="number"
                                                            isInvalid={row.caseOriginId === 0}
                                                            onChange={this.handleEventEditInput}>
                                                            <option key={null} value={0}>Select Case Origin...</option>
                                                            {
                                                                this.state.viewModel.caseOrigins.map((co, idx) => {
                                                                    return <option key={idx} value={co.id}>{co.name}</option>
                                                                })
                                                            }
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control as="select"
                                                            value={row.lineOfBusinessId}
                                                            name="lineOfBusinessId"
                                                            id="lineOfBusinessId"
                                                            data-type="number"
                                                            row={idx}
                                                            isInvalid={row.lineOfBusinessId === 0}
                                                            onChange={this.handleEventEditInput}>
                                                            <option value={0}>Select Line of Business...</option>
                                                            {
                                                                this.state.viewModel.linesOfBusiness.map((lob, idx) => {
                                                                    return <option key={idx} value={lob.id}>{lob.name}</option>
                                                                })
                                                            }
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control as="select"
                                                                      value={row.codingEventQueueId}
                                                                      name="codingEventQueueId"
                                                                      id="codingEventQueueId"
                                                                      row={idx}
                                                                      data-type="number"
                                                                      onChange={this.handleEventEditInput}
                                                                      isInvalid={row.codingEventQueueId === 0}>
                                                            <option value={0}>Select Queue...</option>
                                                            {
                                                                this.state.viewModel.codingEventQueues.map((queue, idx) => {
                                                                    return <option key={idx} value={queue.id}>{queue.name}</option>
                                                                })
                                                            }
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <Form.Control as="select"
                                                            value={row.assignedToId}
                                                            name="assignedToId"
                                                            id="assignedToId"
                                                            row={idx}
                                                            data-type="number"
                                                            onChange={this.handleEventEditInput}disabled={row.codingEventQueueId === 0 ? true : false}>
                                                            <option value={0}>Select Employee...</option>
                                                            {
                                                                row.codingEventQueueId > 0 ?
                                                                    this.state.refDataIndexes.queues[row.codingEventQueueId].members.map((emp, idx) => {
                                                                        return <option key={idx} value={emp.id}>{emp.name}</option>
                                                                    }) : null
                                                            }
                                                        </Form.Control>
                                                    </td>
                                                    <td>
                                                        <FontAwesomeIcon
                                                            icon={faTimesCircle}
                                                            onClick={() => this.handleRemoveRow(idx)}
                                                            className="text-danger givemethefinger" />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    }
                        </table>
                        <br/><br/>
                        {
                            //<div><pre>
                            //{JSON.stringify(this.state, null, 2)}
                            //</pre></div>
                        }
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default connect(null, dispatch => bindActionCreators(modalActionCreator, dispatch))(CodingEventImport);
//export default CodingEventImport;